import styled from 'styled-components'

export const GridArea = styled.div<{ area: string }>`
  grid-area: ${props => props.area};
`

export const FlexGridArea = styled(GridArea)<{ justifyContent?: string, alignItems?: string }>`
  display: flex;
  align-items: ${props => props.alignItems ?? 'center'};
  justify-content: ${props => props.justifyContent ?? 'normal'};
`

export const FlexGridAreaWithMarginTop = styled(FlexGridArea)<{ marginTop: string }>`
  margin-top: ${props => props.marginTop};
`

export const ListGridContainer = styled.div <{ fontSize?: string }>`
  display: grid;
  grid-template-columns: min-content auto;
  ${props => props.fontSize ? `
    font-size:${props.fontSize};
  ` : ''}
`
